<template>
  <div class="col-3" @click="toggleItem" v-if="itemclass === 'focus-areas'">
    <div class="picker-item" :class="{ active: isActive }">
      <div class="image">
        <img :src="itemimg" />
        <h2>{{ itemname }}</h2>
      </div>
    </div>
  </div>

  <div class="col-2" @click="toggleItem" v-else-if="itemclass === 'skills'">
    <div class="picker-item small" :class="{ active: isActive }">
      <div class="image">
        <img :src="itemimg" />
        <h3>{{ itemname }}</h3>
      </div>
    </div>
  </div>

  <div class="col-2" @click="toggleItem" v-else-if="itemclass === 'countries'">
    <div class="picker-item small" :class="{ active: isActive }">
      <div class="image">
        <img :src="itemimg" />
        <h3>{{ itemname }}</h3>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: ['itemid', 'itemname', 'itemimg', 'itemclass'],
  computed: {
    isActive: function () {
      if (this.$parent.selectedItems.indexOf(this.itemid) > -1) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    toggleItem () {
      if (this.$parent.selectedItems.indexOf(this.itemid) > -1) {
        console.log('item exists')
        let index = this.$parent.selectedItems.indexOf(this.itemid)
        console.log(index)
        this.$parent.selectedItems.splice(index, 1)
        this.$parent.selectedItemTags.splice(index, 1)
      } else {
        console.log('Item doesnt exist')
        this.$parent.selectedItems.push(this.itemid)
        this.$parent.selectedItemTags.push({'name': this.itemname, 'id': this.itemid})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// PickerItem.vue?727a82e5